import { render, staticRenderFns } from "./ucb.vue?vue&type=template&id=2133c860&"
import script from "./ucb.vue?vue&type=script&lang=js&"
export * from "./ucb.vue?vue&type=script&lang=js&"
import style0 from "./ucb.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports